import { NotificationEvent, NotificationEventType } from "../common-components/Notifications/Events";
import { GetConfiguration } from "../helpers/helper-functions"

const getUserTeam = async (companyId: string) => {
    const configuration = await GetConfiguration();
    var response = await fetch(`${configuration.companyRelationsUserApiBaseUrl}/api/ManagePeopleQuery/currentuserteam/${companyId}`, {
        method: "get",
        headers: new Headers({
            "Authorization": `Bearer ${window.getTheToken()}`,
            "ContentType": "application/x-www-form-urlencoded"
        })
    })
    if(response.ok)
        return response.json()
}

const getCompanyType = async (companyId: string) => {
    const configuration = await GetConfiguration();
    const response = await fetch(`${configuration.companyMasterDataApiUrl}/customerType/${companyId}`, {
        method: "get",
        headers: new Headers({
            "Authorization": `Bearer ${window.getTheToken()}`,
            "ContentType": "application/x-www-form-urlencoded"
        })
    })
    if(!response.ok){
        const event = new CustomEvent<NotificationEvent>('notificationEvent', {detail: {
            eventType: NotificationEventType.Error,
            message: "Error getting company type"
        }});
        document.dispatchEvent(event);
    }
    return response.text();
}

const getInvoiceIframeUrl = async (companyId: string) => {
    const configuration = await GetConfiguration();
    const response = await fetch(`${configuration.invoicesApiUrl}/${encodeURIComponent(companyId)}`, {
        method: "get",
        headers: new Headers({
            "Authorization": `Bearer ${window.getTheToken()}`,
            "ContentType": "application/json"
        })
    })
    if(response.ok)
        return response.json();
}

const agent = {
    getUserTeam,
    getCompanyType,
    getInvoiceIframeUrl
}

export default agent